import React from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'

export type ServicePreviewState = 'serviceTree' | 'firstRun'

interface ServicePreviewStateBarProps {
  value: ServicePreviewState
  onChange: (value: ServicePreviewState) => void
}

const SEGMENTS: { state: ServicePreviewState; labelKey: string }[] = [
  {
    state: 'serviceTree',
    labelKey: 'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREVIEW_STATE_SERVICE_TREE',
  },
  {
    state: 'firstRun',
    labelKey: 'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREVIEW_STATE_FIRST_RUN',
  },
]

const ServicePreviewStateBar: React.FC<ServicePreviewStateBarProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className='service-preview-state'>
      <span className='service-preview-state__label'>
        {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREVIEW_STATE_LABEL')}
      </span>

      <div
        className='service-preview-state__segments'
        role='group'
        aria-label={t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREVIEW_STATE_LABEL')}
      >
        {SEGMENTS.map(({ state, labelKey }) => (
          <button
            key={state}
            type='button'
            className={`service-preview-state__segment${
              value === state ? ' service-preview-state__segment--active' : ''
            }`}
            aria-pressed={value === state}
            onClick={() => onChange(state)}
          >
            {t(labelKey)}
          </button>
        ))}
      </div>

      <span className='service-preview-state__note'>
        {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PREVIEW_STATE_NOTE')}
      </span>
    </div>
  )
}

export default ServicePreviewStateBar
